import React, { lazy } from 'react';
const bookBase = 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/image_13_1.webp?v=1771013703';
export function BookCTA() {
  return <section className="w-full bg-[var(--bg-darker)] py-8 md:py-12 px-4" data-id="element-75">
      <div className="max-w-4xl mx-auto" data-id="element-76">
        <div className="text-center mb-6 md:mb-8 reveal" data-id="element-77">
          <p className="text-lg md:text-xl lg:text-2xl font-bold text-[var(--accent-orange-light)] mb-3 md:mb-4" data-id="element-78">
            ESTA ES TU OPORTUNIDAD PARA INICIAR ESE NEGOCIO QUE SIEMPRE HAS
            SOÑADO.
          </p>

          <div className="mb-6 md:mb-8" data-id="element-79">
            <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-black text-[var(--text-light)] leading-tight" data-id="element-80">
              DESCARGA AHORA MISMO EL LIBRO QUE TE{' '}
              <span className="text-[var(--accent-orange)]" data-id="element-81">
                CONVERTIRÁ EN UNA ESPECIALISTA
              </span>{' '}
              EN JABONES ARTESANALES
            </h2>
          </div>

          <div className="flex justify-center" data-id="element-82">
            <img src={`${bookBase}&width=560`} srcSet={`${bookBase}&width=320 320w, ${bookBase}&width=560 560w`} sizes="(max-width: 640px) 320px, (max-width: 768px) 384px, 448px" alt="Libro Digital - Secretos de los Jabones de Glicerina" className="w-full max-w-xs md:max-w-sm lg:max-w-md h-auto drop-shadow-2xl" loading="lazy" decoding="async" width={400} height={520} data-id="element-83" />
          </div>
        </div>
      </div>
    </section>;
}